export default {
    baseUrl: process.env.NODE_ENV == 'development' ? 'http://qiyoutong.test' : 'https://api.cnqmp.com',
    // baseUrl: process.env.NODE_ENV == 'development' ? 'http://qiyoutong.test' : 'http://qyt.mqman.com',
    imageUrl: 'https://api.cnqmp.com',
    // imageUrl: 'http://qyt.mqman.com',
    // baseUrl: 'https://saas.mqman.com',
}


// WEBPACK FOOTER //
// ./src/assets/js/config.js